const initialState = {
  convertToCoinsData: {
    proportion: null,
  },
};

const matchers = [
  [
    ({ type }) => type === 'requests/gacha/list/fulfilled',
    (state, { payload: { convertBonusesCost } = {} }) => {
      state.convertToCoinsData.proportion = convertBonusesCost;
    },
  ],
];

export const convertToCoinsSegment = {
  initialState,
  matchers,
};
